import { useKitData } from "@/data/use-kits-data";
import {
  useKitTemplateData,
  useKitTemplatesData,
} from "@/data/use-templates-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { Kit } from "@/types/types";
import { KitQuickSettingsUI } from "./KitQuickSettingsUI";

type TemplateKitQuickSettingsProps = {
  kit: Kit;
};

export const TemplateKitQuickSettings = ({
  kit,
}: TemplateKitQuickSettingsProps) => {
  const groupUuid = useGroupUuid();
  const { updateKit } = useKitData(groupUuid, kit.uuid);
  const { templates } = useKitTemplatesData(groupUuid, kit.uuid);
  const templateUuid = templates[0]?.uuid;
  const { updateTemplate } = useKitTemplateData(
    groupUuid,
    kit.uuid,
    templateUuid,
  );

  return (
    <KitQuickSettingsUI
      kit={kit}
      onNameChange={async (name) => {
        const result = await updateKit({ name });
        if (!result.error && templateUuid) await updateTemplate({ name });
        return result;
      }}
    />
  );
};
